import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const Banner = styled.div`
  text-align: left;
  color: ${p => p.theme.palette.text.high};
`;

export const Heading = styled.h1`
  margin: 0;
  font-size: 28px;
  line-height: 120%;
  font-weight: 700;

  @media (min-width: 768px) {
    font-size: 36px;
  }
`;

export const Subheading = styled.h2`
  margin: 8px 0 0;
  font-size: 28px;
  line-height: 120%;
  font-weight: 400;

  @media (min-width: 768px) {
    font-size: 36px;
  }
`;

export const Copy = styled.p`
  margin: 24px 0 0;
  max-width: 720px;
  font-size: 16px;
  line-height: 150%;

  @media (min-width: 768px) {
    font-size: 18px;
  }
`;
